import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { axiosBeelineRequest } from '@beef/utils';
import { EStatus } from "../../../../constants";
import { poll } from "../../../../utils/fn";
import { isLowerCaseEquals } from "../../../../utils/strings";
import { recursiveMerge } from "../../../../utils/recursiveMerge";
import { ECommonStatus, GET_STATE_URL } from "../../submitPayment/constants";
import { EPaymentStatusConstant } from "../constants";
import { clearParams } from "../utils";
var _request = function request(params) {
  return axiosBeelineRequest({
    url: GET_STATE_URL,
    params: {
      orderId: params.orderId
    }
  });
};
export var cardStrategy = {
  predicate: function predicate(params) {
    return !!params[EPaymentStatusConstant.StatusParameter] && !!params[EPaymentStatusConstant.OrderIdParameter];
  },
  request: function () {
    var _request2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params, content) {
      var _settings$card;
      var status, settings, _recursiveMerge, interval, timeout, _yield$poll, pollStatus;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            clearParams([EPaymentStatusConstant.StatusParameter, EPaymentStatusConstant.OrderIdParameter]);
            status = params[EPaymentStatusConstant.StatusParameter];
            if (!(!status || isLowerCaseEquals(status, EPaymentStatusConstant.Failure))) {
              _context.next = 4;
              break;
            }
            throw new Error('unsuccessful status');
          case 4:
            settings = content.requestSettings;
            _recursiveMerge = recursiveMerge(settings.default, (_settings$card = settings.card) !== null && _settings$card !== void 0 ? _settings$card : {}), interval = _recursiveMerge.interval, timeout = _recursiveMerge.timeout;
            _context.next = 8;
            return poll(function () {
              return _request(params);
            }, function (_ref) {
              var _status = _ref.status;
              return ![ECommonStatus.Error, ECommonStatus.Success].includes(_status);
            }, interval, timeout);
          case 8:
            _yield$poll = _context.sent;
            pollStatus = _yield$poll.status;
            if (pollStatus) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return", undefined);
          case 12:
            if (!isLowerCaseEquals(pollStatus, ECommonStatus.Success)) {
              _context.next = 14;
              break;
            }
            return _context.abrupt("return", EStatus.Success);
          case 14:
            if (!isLowerCaseEquals(pollStatus, ECommonStatus.Process)) {
              _context.next = 16;
              break;
            }
            return _context.abrupt("return", EStatus.Processing);
          case 16:
            return _context.abrupt("return", EStatus.PaymentError);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function request(_x, _x2) {
      return _request2.apply(this, arguments);
    }
    return request;
  }()
};